import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  middleRowWrapper: {
    bottom: Theme.px(20),
    height: Theme.px(339),
    marginLeft: Theme.px(120),
    marginRight: Theme.px(90),
  },
  rowWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
